import dayjs from "dayjs";

export const formatFilterDate = (date) => {
  return dayjs(date).format('YYYY-MM-DD') + 'T00:00:00+00:00';
}

export const formatStartDate = (date) => {
  return dayjs(formatFilterDate(date)).subtract(1, 'second').unix();
}

export const formatEndDate = (date) => {
  return dayjs(formatFilterDate(date)).add(1, 'day').subtract(1, 'second').unix();
}


export const getAllDates = (begin, end) => {// Дата начала и дата окончания
  if (!begin || !end) {// удалить возможность пустого
    return false;
  }
  // Определяем метод форматирования в прототипе Time Date
  Date.prototype.format = function () {
    let s = ""; // Определяем строку, цель - прошить формат времени в соответствии с нашими требованиями
    let month = this.getMonth() + 1;
    let day = this.getDate();
    s += this.getFullYear() + ".";
    s += month + ".";
    s += day;
    return s; // Полученный формат: "2018-11-20"
  }
  let ab = begin.split('.'); // Разделить параметр даты, обратите внимание, что если связано с '/', то разделить '/'
  let ae = end.split('.');
  let db = new Date();
  db.setUTCFullYear(ab [0], ab [1] - 1, ab [2]); // вернуть формат времени в соответствии с UTC
  let de = new Date();
  de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
  let unixDb = db.getTime();
  let unixDe = de.getTime();
  let arr = [];
  for (let k = unixDb; k <= unixDe;) {
    arr.push(new Date(parseInt(k)));
    k = k + 24 * 60 * 60 * 1000;
  }
  return arr.map((d) => {
    return dayjs(d).format()
  }); // Возвращаем все массивы дат между двумя датами.
}


export const getCurrentMonth = (name) => {
  if (!name) {
    return
  }
  const month = name.split('-')[0]
  const months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль",
    "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"]
  return (months.findIndex((m) => m.toLowerCase() === month.toLowerCase()) || 0) + 1
}


export const sortPlanByDate = (array) => {
  const monthNumbers = {
    'январь': 1,
    'февраль': 2,
    'март': 3,
    'апрель': 4,
    'май': 5,
    'июнь': 6,
    'июль': 7,
    'август': 8,
    'сентябрь': 9,
    'октябрь': 10,
    'ноябрь': 11,
    'декабрь': 12
  };

  array.sort((a, b) => {
    const [monthA, yearA] = a.name.split('-');
    const [monthB, yearB] = b.name.split('-');

    // Преобразуем месяцы в числа
    const numA = monthNumbers[monthA.toLowerCase()] + 12 * parseInt(yearA);
    const numB = monthNumbers[monthB.toLowerCase()] + 12 * parseInt(yearB);

    // Возвращаем разницу
    return numA - numB;
  });
  const direct = {...array[0]};

  array.splice(0, 1)
  return [direct, ...array.reverse()]
}



// WEBPACK FOOTER //
// ./src/utils/date.js